export default __webpack_public_path__ + "static/media/Roboki.7c465af8.png";